import { useState, useEffect } from "react";

const useProgressIndicatorOverlay = ({ isInProgress, onRemovedCallback }) => {
  const [isInDOM, setIsInDOM] = useState(isInProgress);
  const [isVisible, setIsVisible] = useState(!isInProgress);

  useEffect(() => {
    setIsVisible(isInProgress);
    if (isInProgress) {
      setIsInDOM(true);
    }
  }, [isInProgress]);

  const onAnimationEnd = () => {
    if (!isInProgress) {
      setIsInDOM(false);
      if (onRemovedCallback) {
        onRemovedCallback();
      }
    }
  };

  return { onAnimationEnd, isInDOM, isVisible };
};

export default useProgressIndicatorOverlay;
